import {tradeDetailControls, TradeDetailControls} from "./trade-detail/controls/TradeDetailControls";
import {tradeLimit, TradeLimit} from "./trade-detail/controls/TradeLimit";
import {tradeDetailQuantity, TradeDetailQuantity} from "./trade-detail/controls/TradeQuantity";
import {optionTradeDescription, OptionTradeDescription} from "./trade-detail/description/option/OptionTradeDescription";
import {equityTradeDescription, EquityTradeDescription} from "./trade-detail/description/equity/EquityTradeDescription";
import {tradeSpreadSummary, TradeSpreadSummary} from "./trade-detail/spread/TradeSpreadSummary";
import {optionTradeTitle, OptionTradeTitle} from "./trade-detail/title/OptionTradeTitle";
import {tradePricingInstruction, TradePricingInstruction} from "./trade-detail/controls/TradePricingInstruction";

export default angular.module("tfApp.components.trade", [])
                      .component(TradeDetailControls, tradeDetailControls())
                      .component(TradeLimit, tradeLimit())
                      .component(TradePricingInstruction, tradePricingInstruction())
                      .component(TradeDetailQuantity, tradeDetailQuantity())
                      .component(OptionTradeDescription, optionTradeDescription())
                      .component(EquityTradeDescription, equityTradeDescription())
                      .component(TradeSpreadSummary, tradeSpreadSummary())
                      .component(OptionTradeTitle, optionTradeTitle())
                      .name;
